import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable, catchError, map, of, throwError, EMPTY } from "rxjs";
import { AuthService } from "@modules/auth/services/auth.service";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTES_AUTH } from "@modules/auth/enums/routes-auth.enum";
import { ToastService } from "../services/toast.service";

export default function httpResponseInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    
    const toastService: ToastService = inject(ToastService);
    const authService = inject(AuthService);
    const router = inject(Router);
    
    return next(req)
    .pipe(
        map((event: HttpEvent<unknown>) => {
            if(event.type === HttpEventType.Response){
                return event.clone({
                    body: (event.body as any).data
                });
            }
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
            if(error.status === 0){
                toastService.show({ severity: 'error', summary: 'Error de conexión', detail: 'Error al conectar con el servidor', life: 3000 });
            }

            if(error.status === 401){
                authService.logout();
                router.navigate([ROUTES_AUTH.LOGIN]);
            }
            return throwError(() => error.error ?? error);
        })
    )
}
    